import { render, staticRenderFns } from "./alert_detail.vue?vue&type=template&id=42622fda&scoped=true"
import script from "./alert_detail.vue?vue&type=script&lang=js"
export * from "./alert_detail.vue?vue&type=script&lang=js"
import style0 from "./alert_detail.vue?vue&type=style&index=0&id=42622fda&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42622fda",
  null
  
)

export default component.exports